export const formatPrice = (val) =>
  `R$${(val || 0).toFixed(2).replace('.', ',')}`;

export const formatDate = (ts) => {
  if (!ts) return '—';
  const d = ts.toDate ? ts.toDate() : new Date(ts);
  return d.toLocaleDateString('pt-BR', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  });
};

export const getPieceCount = (items = []) =>
  items.reduce((sum, item) => sum + (item.quantity || 1), 0);

export const getItemsSubtotal = (items = []) =>
  items.reduce((sum, item) => sum + (item.price || 0) * (item.quantity || 1), 0);

export const formatItemsSummary = (items = []) => {
  if (!items.length) return '—';
  const pieces = getPieceCount(items);
  if (items.length === 1) {
    const item = items[0];
    const qty = item.quantity || 1;
    const label = `${item.name}${item.size ? ` (${item.size})` : ''}`;
    return qty > 1 ? `${label} × ${qty}` : label;
  }
  return `${items.length} produtos · ${pieces} ${pieces === 1 ? 'peça' : 'peças'}`;
};

const STATUS_LABELS = {
  pago: 'Pago',
  processando: 'Em processamento',
  enviado: 'Enviado',
  entregue: 'Entregue',
  cancelado: 'Cancelado',
};

const STATUS_NEXT = {
  pago: 'processando',
  processando: 'enviado',
  enviado: 'entregue',
  entregue: null,
};

export const getNextOrderStatus = (order) =>
  STATUS_NEXT[order.status] || null;

export const getStatusLabel = (status, localDelivery = false) => {
  if (localDelivery && status === 'enviado') return 'Saiu para entrega';
  return STATUS_LABELS[status] || status;
};

export const getNextStatusActionLabel = (order) => {
  const next = getNextOrderStatus(order);
  if (!next) return null;
  return getStatusLabel(next, order.localDelivery);
};

export const orderNeedsTracking = (order, nextStatus) =>
  nextStatus === 'enviado' && !order.localDelivery;

export const buildOrderItems = (sessionDetails, cartItems = []) => {
  const stripeItems = sessionDetails?.items || [];
  if (stripeItems.length > 0) {
    return stripeItems.map((si) => {
      const cartMatch = cartItems.find(
        (c) => c.name === si.name && (c.size || null) === (si.size || null)
      );
      return {
        productId: cartMatch?.id || si.productId || null,
        name: si.name,
        size: si.size || null,
        quantity: si.quantity || 1,
        price: si.price || 0,
      };
    });
  }

  return cartItems
    .filter((item) => (item.priceValue || 0) > 0)
    .map((item) => ({
      productId: item.id || null,
      name: item.name,
      size: item.size || null,
      quantity: item.quantity || 1,
      price: item.priceValue || 0,
    }));
};
